import { useState } from "react";
import * as Animate from "react-reveal";
import YouTube from "react-youtube";

import VideoImage1 from "../../../assets/images/png/home/video/chisom.webp";
import VideoImage2 from "../../../assets/images/png/home/video/gilbert.webp";
import VideoImage3 from "../../../assets/images/png/home/video/ruth.webp";

const videos = [
  {
    id: 1,
    videoId: "-087VdLBBNM",
    image: VideoImage1,
    name: "Chisom Mbama",
    label: "Learning experience",
    description:
      "How practical, coach-led learning turns complex ideas into work learners can explain.",
  },
  {
    id: 2,
    videoId: "hXJGvB3MV04",
    image: VideoImage2,
    name: "Gilbert Odumosu",
    label: "Portfolio and progress",
    description:
      "Stories about completing projects, building evidence and making progress visible.",
  },
  {
    id: 3,
    videoId: "UIWDmFP8Cw0",
    image: VideoImage3,
    name: "Ruth Agbasimalo",
    label: "Career confidence",
    description:
      "Perspectives on professional growth, workplace readiness and what comes next.",
  },
];

const PlayButton = () => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="32.5"
      cy="32.5"
      r="31.5"
      fill="var(--color-primary)"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M42 31.2679C43.3333 32.0378 43.3333 33.9622 42 34.7321L28.5 42.5263C27.1667 43.2963 25.5 42.334 25.5 40.7942V25.2058C25.5 23.666 27.1667 22.7037 28.5 23.4737L42 31.2679Z"
      fill="white"
    />
  </svg>
);

const VideoCard = ({ video, isPlaying, onPlay }) => {
  return (
    <div className="bg-white rounded-3xl border border-hire-line overflow-hidden h-full flex flex-col">
      <div className="relative h-60 md:h-64 lg:h-72 bg-primary">
        {isPlaying ? (
          <YouTube
            videoId={video.videoId}
            opts={{
              width: "100%",
              height: "100%",
              playerVars: { autoplay: 1, rel: 0 },
            }}
            containerClassName="w-full h-full"
            containerStyle={{ width: "100%", height: "100%" }}
          />
        ) : (
          <button
            type="button"
            onClick={onPlay}
            className="w-full h-full block relative"
            aria-label={`Play video: ${video.name}`}
          >
            <img
              src={video.image}
              alt={video.name}
              className="w-full h-full object-cover"
            />
            <span className="absolute inset-0 flex items-center justify-center">
              <PlayButton />
            </span>
          </button>
        )}
      </div>
      <div className="p-6 md:p-7 flex-1">
        <span className="text-secondary tracking-[0.09em] font-poppins text-xs font-extrabold uppercase">
          Watch Utiva stories
        </span>
        <h3 className="mt-2 mb-2 text-primary font-poppins font-bold text-xl">
          {video.label}
        </h3>
        <p className="text-gray font-poppins text-sm leading-[1.7]">
          {video.description}
        </p>
      </div>
    </div>
  );
};

const HomeTestimonialVideosSection = () => {
  const [playingId, setPlayingId] = useState(null);

  return (
    <section className="bg-[#f7f9fe] py-16 md:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="grid home-grid-1115 items-end gap-6 lg:gap-20 mb-10 md:mb-12">
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
                <span className="w-8 h-[3px] bg-secondary inline-block"></span>
                Video testimonials
              </p>
              <h2 className="text-primary font-poppins font-bold tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-6xl">
                More stories, in their own voices.
              </h2>
            </div>
            <p className="text-gray text-base font-poppins leading-[1.8]">
              Watch learners and alumni talk about practical learning, portfolio
              growth and the confidence to take their next step.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {videos.map((video) => (
            <Animate.Fade bottom key={video.id}>
              <VideoCard
                video={video}
                isPlaying={playingId === video.id}
                onPlay={() => setPlayingId(video.id)}
              />
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonialVideosSection;
